import { createSlice } from "@reduxjs/toolkit";

interface stateType {
  isLogin: boolean;
}

const initialState: stateType = {
  isLogin: false,
};

export const loginSlice = createSlice({
  name: "loginSlice",
  initialState,
  reducers: {
    loginFunc: (state) => {
      state.isLogin = true;
    },
  },
});

export const { loginFunc } = loginSlice.actions;

export default loginSlice.reducer;
